import React from 'react';

/** Quote — pull quote / testimonial. data: { text, author?, role? } */
export default function Quote({ data = {} }) {
  const { text = '', author, role } = data;
  if (!text) return null;
  return (
    <section data-testid="site-block-quote">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <blockquote className="text-xl lg:text-2xl orka-text-primary leading-relaxed font-medium">
          &ldquo;{text}&rdquo;
        </blockquote>
        {(author || role) && (
          <div className="mt-4 text-sm orka-text-tertiary">
            {author}{author && role ? ' · ' : ''}{role}
          </div>
        )}
      </div>
    </section>
  );
}
